import { SerializedStyles, css } from "@emotion/react";
import { kebabCase } from "lodash";

export function hasValueProvided(value: string | number): boolean {
  return value !== null && value !== undefined;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type StyleFn = (props: any) => SerializedStyles | null;

export function styleCss(propName: string, cssPropName?: string, important?: boolean): StyleFn {
  return props =>
    hasValueProvided(props[propName])
      ? css`
          ${cssPropName || kebabCase(propName)}: ${props[propName]}${important ? " !important" : ""};
        `
      : null;
}
